import { Loading } from 'element-ui';

let loadingInstance = null;
let needLoadingRequestCount = 0; // 记录当前正在进行的加载数

export const showLoading = (text = '正在处理中...') => {
    if (needLoadingRequestCount === 0) {
        loadingInstance = Loading.service({
            lock: true,
            text: text,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            // 显式指定全屏
            target: document.body, 
            fullscreen: true 
        });
    }
    needLoadingRequestCount++;
};

export const hideLoading = () => {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0 && loadingInstance) {
        loadingInstance.close();
        loadingInstance = null;
    }
};